import { useDispatch } from 'react-redux';
import { Earning, EarningIcon } from './EarningsHistoryStyled';
import { formatUSD, USDT } from '../../../helpers/helperFunctions';
import { CaptionText, P2 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconEarningsCheck,
  IconEarningsLock
} from '../../../styles/Icons';
import { FlexCenter } from '../../../styles/stylesStyled';
import { getEarningDetails } from '../Earnings.actions';
import { Dispatch, SetStateAction } from 'react';
import moment from 'moment';
import { Flexed } from '../../../styles/GlobalComponents';

const getStatusIcon = (status: number) => {
  switch (status) {
    case 1:
      return (
        <Icon color={color.colors.secondary100}>
          <IconEarningsLock />
        </Icon>
      );
    case 2:
      return (
        <Icon color={color.colors.secondary100}>
          <IconEarningsCheck />
        </Icon>
      );
    default:
      return '';
  }
};

interface EarningsHistoryItemProps {
  earning: any;
  setIsEarningsDetailsOpened: Dispatch<SetStateAction<boolean>>;
}

export const EarningsHistoryItem = ({
  earning,
  setIsEarningsDetailsOpened
}: EarningsHistoryItemProps) => {
  const dispatch = useDispatch();

  return (
    <>
      <Earning
        onClick={() => {
          setIsEarningsDetailsOpened(true);
          dispatch(getEarningDetails({ type: earning.type, id: earning.id }));
        }}>
        <FlexCenter>
          <EarningIcon>{getStatusIcon(earning?.status)}</EarningIcon>
          <div>
            <P2 color={color.colors.neutral900}>{earning?.name}</P2>
            <CaptionText color={color.colors.neutral500}>
              {earning?.type === 12
                ? `Received: ${moment(earning?.dateCreated).format(
                    'MMM D, YYYY'
                  )}`
                : earning?.username}
            </CaptionText>
          </div>
        </FlexCenter>
        <Flexed column alignEnd>
          <P2
            color={
              earning?.status === 1
                ? color.colors.neutral500
                : color.colors.neutral900
            }>
            {earning?.amount >= 0 && earning?.type !== 12 && '+'}{' '}
            {formatUSD(earning?.amount)} {earning?.type !== 12 && USDT}
          </P2>
          {earning?.type === 12 && (
            <CaptionText color={color.colors.neutral500}>
              {earning?.type === 12
                ? `Use by: ${moment(earning?.dateCreated)
                    .add(1, 'year')
                    .format('MMM D, YYYY')}`
                : earning?.username}
            </CaptionText>
          )}
        </Flexed>
      </Earning>
    </>
  );
};
